import { Routes, Route } from "react-router";

import { PodcastTechInstructionsComponent } from "./podcastTechInstructions";
import { PageNotFound } from "../../pageNotFound";
import { BannerWithHeading } from "../../../generic/layout/bannerWithHeading";
import { Box, VStack, Image, useBreakpointValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import ML_UNPLUGGED_2025_Regular from "./media/ML_UNPLUGGED_2025_Regular.png";
import ML_UNPLUGGED_2025_Regular_NoLogo from "./media/ML_UNPLUGGED_2025_Regular_NoLogo.png";
import { UnpluggedLandingComponent } from "./landing";

export function ArbitratorInterviewsComponent() {
  const { t } = useTranslation();
  const logHeight = useBreakpointValue({ base: 40, md: 60 }, { ssr: false });
  return (
    <Routes>
      <Route
        path="instructions"
        element={<PodcastTechInstructionsComponent />}
      />
      <Route path="*" element={<UnpluggedLandingComponent />} />
    </Routes>
  );
}
